<div class="col-lg-12">
  <div class="col-lg-4">
    <div class="form-group mb-3">
      <label class="form-label" for="keywordAlgorithmName">
        Keyword Extraction Algorithm:
      </label>
      <select
        class="form-control"
        id="keywordAlgorithmName"
        [(ngModel)]="options['keywordExtractionAlgorithm']">
        <option>TEXTRANK</option>
        <option>TFIDF</option>
        <option>TFIDF_NGRAM</option>
        <option>TFIDF_WIKIPEDIA</option>
      </select>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="form-group mb-3">
      <label class="form-label" for="numberOfKeywords">
        Number of Keywords:
      </label>
      <input
        class="form-control"
        type="number"
        id="numberOfKeywords"
        name="numberOfKeywords"
        min="1"
        max="200"
        [(ngModel)]="options['n_keywords']" />
    </div>
  </div>
  <div class="col-lg-12">
    <div
      class="btn btn-primary"
      [ngClass]="{ disabled: requestInProgress }"
      (click)="syncIdeas()">
      Sync Ideas
    </div>
  </div>
</div>
